import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import LoginModal from "./components/LoginModal";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import ScrollToTop from './components/ScrollToTop';

export default function App() {
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <Router>
      <ScrollToTop />
      <Nav onOpenLogin={() => setLoginOpen(true)} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
      <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />
    </Router>
  );
}
